import { SET_LOADER } from '../actions';

export const setLoaderAction = (loading: boolean) =>
  SET_LOADER({ payload: { isLoading: loading } });
